import SponsorChoose from './src/main.js';

export default SponsorChoose;
